import AssetTable from "../../components/asset-management/AssetTable";

const AssetReport = ({ toggle }) => {
  return <AssetTable toggle={toggle} reportType={"Housekeeping Report"} />;
};
export default AssetReport;
